import React, {useState} from 'react';
import PropTypes from 'prop-types';

import '../../styles/scss/elements/accommodation-input.scss';

import { onEnter } from '../../utilities/accessibility/onEnter';

const AccommodationInput = ({headerLabel, inputLabel, onChangeText, value}) => {
  const [isChecked, setIsChecked] = useState(false);

  function onToggleCheckbox() {
    onChangeText('');
    setIsChecked(!isChecked);
  }

  return (
    <div className="u-flex u-flex-column accommodation-input">
      <span aria-label={headerLabel}>{headerLabel}</span>
      <div className="u-flex u-flex-align-center input-container">
        <input
          id="accommodation-check"
          className="input-container__checkbox"
          onClick={onToggleCheckbox}
          onKeyDown={event => onEnter(event, onToggleCheckbox)}
          type="checkbox"
          value={isChecked}
        />
        <label
          className="checkbox-label"
          htmlFor="accommodation-check"
        >
          Yes
        </label>
      </div>
      {isChecked && (
        <div className="u-flex u-flex-column input-container">
          <label
            className="text-input-label"
            htmlFor="accommodation-input"
          >
            {inputLabel}
          </label>
          <input
            id="accommodation-input"
            className="text-input"
            onChange={event => onChangeText(event.target.value)}
            value={value}
          />
        </div> 
      )}
    </div>
  )
};

AccommodationInput.propTypes = {
  headerLabel: PropTypes.string.isRequired,
  inputLabel: PropTypes.string.isRequired,
  onChangeText: PropTypes.func.isRequired,
  value: PropTypes.string,
};

AccommodationInput.defaultProps = {
  value: '',
};

export default AccommodationInput;
